import React, { useMemo } from 'react';
import shopSelectors from 'services/shop/selectors';

const useLoyaltyRedeem = () => {
  const loyaltySetting = shopSelectors.data.getLoyaltySetting();
  const loyaltyRedeemConfig = shopSelectors.data.loyaltyRedeemConfig();

  const exchangeDollar = (point: number) => {
    if (!loyaltySetting) return 0;
    const val = +(point) / loyaltySetting?.oneDollarToPoint;
    return val;
  };

  const calcMaxLoyaltyAmount = (customerPoint: number) => {
    const customerAmount = exchangeDollar(customerPoint || 0) || 0;
    const maxAmount = loyaltyRedeemConfig?.maxAmount || 0;
    return Math.min(customerAmount, maxAmount);
  };

  return {
    calcMaxLoyaltyAmount,
    exchangeDollar,
    loyaltyRedeemConfig
  };
};

export default useLoyaltyRedeem;
